import { render, staticRenderFns } from "./OpinewAppStoreReviewRequestModal.vue?vue&type=template&id=3e980c17&scoped=true"
import script from "./OpinewAppStoreReviewRequestModal.vue?vue&type=script&lang=js"
export * from "./OpinewAppStoreReviewRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e980c17",
  null
  
)

export default component.exports